// 管理端操作 bkey 配置文件
export default {
  MANAGE_BKEY_LIST_CONFIG: {
    A01: "affiliate.web.query",
    A02: "affiliate.web-detail.view",
    A03: "affiliate.web-detail.edit",
    A04: "affiliate.web-detail-wlb.edit",
    A05: "",
    A06: "affiliate.web-detail-contract.view",
    A07: "affiliate.web-detail-contract.edit",
    A08: "affiliate.web-detail-contract.delete",
    A09: "affiliate.cid-data.query",
    A10: "affiliate.cid-report.query",
    A11: "affiliate.cid-transaction.query",
    A12: "affiliate.cid-transaction-download.view",
    A13: "affiliate.cid-transaction.download",
    A14: "affiliate.cid-transaction.asyncdownload",
    A15: "affiliate.cid-settlement.query",
    A16: "affiliate.cid-settlement-orderlist.query",
    A17: "affiliate.cid-settlement-orderlist-download.view",
    A18: "affiliate.cid-settlement-orderlist.download",
    A19: "affiliate.cid-settlement-orderlist.asyncdownload",
    A20: "affiliate.cid-settlement-invoice.query",
    A21: "affiliate.cid-settlement-invoice.update",
    A22: "affiliate.cid-settlement-invoice.upload",
    A23: "affiliate.cid-settlement-invoice.download",
    A24: "affiliate.cid-clicks.query",
    A25: "affiliate.cid-cvr.query",
    A26: "affiliate.cid-settlement-invoice.query",
    A27: "affiliate.cid-settlement-statement.download",
    A28: "affiliate.cid-settlement-statement.update",
    A29: "affiliate.web-detail-transfer-account.edit",
    A30: "",
    A31: "affiliate.cid-settlement-laber-report.view",
    A32: "affiliate.cid-settlement-laber-report.download",
    A33: "affiliate.cid-settlement-laber-signed-doc.download",
    A34: "affiliate.cid-settlement-laber-report-return.update",
    // B - 近期活動
    B01: "affiliate.events.query",
    B02: "affiliate.events.create",
    B03: "affiliate.events.edit",
    B04: "affiliate.events-media.view",
    B05: "affiliate.events-media.create",
    B06: "affiliate.events-media.edit",
    B07: "affiliate.events-media.delete",
    B08: "affiliate.events-product.view",
    B09: "affiliate.events-product.create",
    B10: "affiliate.events-product.edit",
    B11: "affiliate.events-product.delete",
    // C - 通知中心
    C01: "affiliate.notifications.query",
    C02: "affiliate.notifications.create",
    C03: "affiliate.notifications.upload",
    // D - 工具
    D01: "affiliate.customize-rule.query",
    D02: "affiliate.customize-rule-specific-cid.query",
    D03: "affiliate.customize-rule-detail.view",
    D04: "affiliate.customize-rule-limited.apply", // 新增
    D05: "affiliate.customize-rule.apply",
    D06: "affiliate.customize-rule-limited.create", // 审核
    D07: "affiliate.customize-rule.create",
    D08: "affiliate.customize-rule-limited.edit",
    D09: "affiliate.customize-rule.edit",
    D10: "affiliate.customize-rule.delete",
    D11: "affiliate.customize-rule.sort",
    D12: "affiliate.tool-settlement.query",
    D13: "affiliate.tool-settlement-cid.exist",
    D14: "affiliate.tool-settlement.download",
    D15: "affiliate.tool-settlement-payment.view",
    D16: "affiliate.tool-settlement-payment-invoice.upload",
    D17: "affiliate.tool-settlement-link.query",
    D18: "affiliate.tool-settlement-payment-confirm.edit",
    D19: "affiliate.tool-settlement-payment-BPM.edit",
    D21: "affiliate.tool-settlement-payment-invoice.view",
    D22: "affiliate.tool-settlement.download-async",
    D23: "affiliate.tool-settlement.download-status.view",
    D24: "affiliate.customize-rule-under-review.edit",
    D25: "affiliate.tool-sponsor-whitelist.view",
    D26: "affiliate.tool-sponsor-whitelist.query",
    D27: "affiliate.tool-sponsor-whitelist.update",

    // E - 會員獎勵
    E01: "affiliate.sponsor-list.query",
    E02: "affiliate.sponsor-detail.view",
    E03: "affiliate.sponsor-detail-status.edit",
    E04: "affiliate.sponsor-pord-detail-prod.edit",
    E05: "affiliate.sponsor-pord-detail-comment.edit",
    E06: "affiliate.sponsor-detail.download",
    E07: "affiliate.sponsor-pord-detail-prod.view"
  }
}
